const TWO_DECIMAL_REGEX = /^-?\d+(\.\d{1,2})?$/;

export function validateTwoDecimal(number) {
  return TWO_DECIMAL_REGEX.test(number);
}